export default __webpack_public_path__ + "static/media/redux.ece8a76b.webp";